/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_ConfirmInputs */

const vi_chot_so_confirm = /** @type {(inputs: Chot_So_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu kiểm kê tồn kho cho hôm nay?`)
};

/**

* @param {Chot_So_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_confirm = /** @type {((inputs?: Chot_So_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_confirm(inputs)
});